"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const roundNumberWithDecimals = (number, precision = 0) => {
    return Math.round((number + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision);
};
exports.default = roundNumberWithDecimals;
